import styled                          from "styled-components";
import { TimePicker, TimePickerProps } from 'antd';
import { borderColor }                 from "Public/Css/colors";

export default styled( TimePicker )<TimePickerProps> `
    width: 100%;
    display: inline-block;
    
    &.ant-picker-small {
        max-width: 110px;
        border: solid 1px;
        font-size: 14px;
        height: 24px;

        
        input {
            font-size: 14px;
            padding: 0;
            height: 100%;
        }
    }
    
    &.yearPicker {
        max-width: 130px;
    }
    
    input {
        border: solid 0 ${ borderColor };
        border-radius: 4px;
        font-size: 16px;
        padding-top: 11px;
        padding-bottom: 10px;
        height: 40px;
        width: 100%;
    }

    .ant-picker-input > input:focus, .ant-picker-input > input:hover, .ant-picker-input > input-focused {
        border: none;
    }
`;
